/**
 * progressService.js — Gestion locale de la progression formation
 * Stocke dans localStorage l'avancement de chaque module pour l'utilisateur connecté.
 * Schéma : { [moduleId]: { startedAt, completedAt, lastSlide, quizScores: {slideId: bool} } }
 */
const STORAGE_KEY = 'baobab_training_progress_v1';

const safeParse = (raw) => {
  try { return raw ? JSON.parse(raw) : {}; } catch { return {}; }
};

export const getAllProgress = () => safeParse(localStorage.getItem(STORAGE_KEY));

export const getModuleProgress = (moduleId) => {
  const all = getAllProgress();
  return all[moduleId] || null;
};

export const markSlideViewed = (moduleId, slideIndex, totalSlides) => {
  const all = getAllProgress();
  const cur = all[moduleId] || { startedAt: new Date().toISOString(), lastSlide: 0, completedAt: null, quizScores: {} };
  cur.lastSlide = Math.max(cur.lastSlide, slideIndex);
  // Module considéré complété quand la dernière slide est atteinte
  if (slideIndex >= totalSlides - 1 && !cur.completedAt) {
    cur.completedAt = new Date().toISOString();
  }
  all[moduleId] = cur;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  return cur;
};

export const recordQuizAnswer = (moduleId, slideId, isCorrect) => {
  const all = getAllProgress();
  const cur = all[moduleId] || { startedAt: new Date().toISOString(), lastSlide: 0, completedAt: null, quizScores: {} };
  cur.quizScores[slideId] = isCorrect;
  all[moduleId] = cur;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
};

export const resetProgress = (moduleId) => {
  const all = getAllProgress();
  delete all[moduleId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
};

/**
 * Calcule les statistiques de progression pour une population.
 * Retourne : { completedCount, startedCount, totalModules, percent, badges }
 */
export const getPopulationStats = (catalog) => {
  const all = getAllProgress();
  const completed = catalog.filter((m) => m.available && all[m.id]?.completedAt).length;
  const started = catalog.filter((m) => m.available && all[m.id] && !all[m.id].completedAt).length;
  const totalAvailable = catalog.filter((m) => m.available).length;
  const percent = totalAvailable > 0 ? Math.round((completed / totalAvailable) * 100) : 0;

  // Badges progressifs
  const badges = [];
  if (completed >= 1) badges.push({ id: 'first-step', label: 'Premier pas', emoji: '🎯' });
  if (completed >= 3) badges.push({ id: 'engaged', label: 'Engagé', emoji: '⚡' });
  if (completed >= 5) badges.push({ id: 'half-way', label: 'À mi-chemin', emoji: '🏃' });
  if (completed >= 10) badges.push({ id: 'expert', label: 'Expert', emoji: '🏆' });
  if (percent === 100 && totalAvailable >= 10) badges.push({ id: 'master', label: 'Maître Baobab', emoji: '👑' });

  return { completedCount: completed, startedCount: started, totalModules: totalAvailable, percent, badges };
};
